import { useStoreState } from "pullstate";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AppStore } from "../stores/AppStore.js";
import { api } from "./../utils/apiFunctions";
import getRedirectURI from "../utils/getRedirectURI.js";

const SlackCallback = () => {
    const navigate = useNavigate();
    const user = useStoreState(AppStore, (s) => s.user);

    const getSlackToken = async () => {
        if (!user) return;

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");

        if (code) {
            try {
                const redirecturi = getRedirectURI()
                const response = await api.post("/slack/api/auth", { code, user, redirecturi });

                AppStore.update((s) => {
                    s.slackUserData = response.data;
                });

                console.log("Slack login successful:", response.data);
                navigate("/employee");
            } catch (error) {
                console.error("Error authenticating with Slack:", error);
            }
        }
    };

    useEffect(() => {
        if (user) {
            getSlackToken();
        }
    }, [user]);

    return <div style={{ color: "white" }}>Authenticating...</div>;
};

export default SlackCallback;
